var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "patternI",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.48,225c.09-11.82,8.71-20.44,20.53-20.52,11.69-.08,20.51,8.98,20.47,21.02-.05,11.73-8.86,20.45-20.57,20.35-12.26-.1-20.52-8.53-20.43-20.85Z",
    className: "patternColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M556.69,230.41c-13.27.02-20.67-5.76-22.08-14.51-1.54-9.59,3.31-17.92,12.08-20.73,5.99-1.92,9.31-.41,14.45,6.44,2.25,3.01,4.3,6.27,7.02,8.8,3.36,3.14,3.02,6.38,1.35,9.86-3.26,6.78-8.85,9.99-12.82,10.13h0Z",
    className: "patternColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M323.74,627.52c8.14-.09,14.93,4.98,16.57,12.36,1.7,7.68-1.99,15.43-9.19,18.51-1.5.64-3.68.35-5.33-.17-3.24-1.01-6.31-2.55-9.5-3.76-9.26-3.52-11.68-13.3-5.14-21.04,3.28-3.87,7.4-6.06,12.6-5.9h-.01Z",
    className: "patternColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.45,201.71c-.05,7.8-5.97,13.66-13.85,13.71-7.72.05-13.74-5.95-13.89-13.84-.15-7.53,6.15-13.98,13.75-14.08,7.87-.1,14.05,6.17,13.99,14.21h0Z",
    className: "patternColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.29,298.54c-8.34,0-13.82-5.39-13.81-13.58,0-8.18,5.47-13.54,13.78-13.51,8.09.03,13.9,5.61,14.1,13.54.19,7.45-6.14,13.54-14.06,13.54h-.01Z",
    className: "patternColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M564.62,535.46c5.15-.42,9.38,2.05,11.73,6.87,1,2.04.53,4.89.41,7.35-.06,1.24-.93,2.42-1.23,3.67-1.72,7.08-4.27,9.5-10.57,9.92-6.09.41-11.68-3.41-13.75-9.39-3.31-9.53,2.99-18.47,13.41-18.43h0Z",
    className: "patternColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M259.32,415.56c-8.04-.02-13.65-5.39-13.69-13.08-.04-7.63,6.13-13.89,13.77-13.97,7.56-.08,13.75,6.27,13.65,14-.1,7.82-5.63,13.08-13.73,13.05Z",
    className: "patternColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M462.43,546.41c.04-8.18,5.12-13,13.62-12.91,7.41.08,12.54,5.43,12.55,13.08,0,8.16-5.3,13.45-13.44,13.23-7.14-.19-13.51-5.39-12.73-13.4h0Z",
    className: "patternColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M254.13,355.46c-7.71,0-13.32-5.43-13.37-12.95-.05-7.03,5.79-12.94,12.9-13.04,7.54-.11,13.78,6.01,13.67,13.38-.11,7.18-5.78,12.61-13.19,12.61h-.01Z",
    className: "patternColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M515.59,477.46c8.01,0,12.93,4.92,12.91,12.94-.01,7.4-5.46,13.04-12.62,13.07-7.46.03-13.24-5.6-13.35-12.99-.1-7.48,5.45-13.02,13.05-13.03h.01Z",
    className: "patternColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M434.49,616.36c-.06,6.8-5.46,12.08-12.42,12.14-6.74.06-12.7-6.02-12.53-12.78.17-6.52,6-12.12,12.64-12.16,6.95-.04,12.37,5.6,12.31,12.8Z",
    className: "patternColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M336.48,548.14c-.01,6.75-5.75,12.43-12.34,12.22-6.87-.22-11.77-5.53-11.71-12.69.06-7.2,5.12-12.27,12.13-12.14,6.73.12,11.94,5.63,11.92,12.62h0Z",
    className: "patternColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.07,487.39c7.28-.06,11.71,4.25,11.96,11.68.22,6.41-4.9,11.41-11.67,11.42-6.69,0-11.67-4.83-11.74-11.4-.07-6.63,4.83-11.63,11.45-11.69h0Z",
    className: "patternColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M527.17,390.37c5.02.07,9.23,4.28,9.19,9.21-.04,5.21-4.04,9.22-9.15,9.18-5.35-.05-8.86-4.01-8.76-9.86.1-5.52,3.25-8.61,8.72-8.53h0Z",
    className: "patternColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M585.54,328.46c5.07.09,8.08,3.32,8.01,8.57-.07,5.12-3.46,8.54-8.33,8.41-4.57-.12-8.6-4.09-8.68-8.55-.09-4.75,3.94-8.53,8.99-8.43h.01Z",
    className: "patternColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M367.06,129.5c.84,7.76-1.38,12.01-6.97,13.91-5.22,1.77-10.6-.05-13.38-4.53-2.12-3.42-1.44-4.7,2.57-5.5,5.85-1.16,11.66-2.53,17.78-3.88Z",
    className: "patternColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M177.31,554.02c.1-4.74,3.45-7.75,8.42-7.57,4.43.16,7.85,3.78,7.63,8.07-.2,3.95-4.27,7.87-8.2,7.91-4.37.04-7.95-3.79-7.85-8.41Z",
    className: "patternColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M553.54,595.64c-2.81,3.38-5.7,6.22-7.81,9.55-2.34,3.7-4.97,2.96-6.5.28-1.46-2.55-2.56-6.37-1.69-8.91.85-2.49,4.09-5,6.8-5.83,3.86-1.18,7.38.65,9.21,4.91h-.01Z",
    className: "patternColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M447.49,349.53c-.08,4.37-2.8,7.03-7.2,7.05-4.07.02-7.37-3.14-7.4-7.1-.04-4.16,3.46-7.51,7.69-7.36,4.26.15,6.99,3.08,6.91,7.41Z",
    className: "patternColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M398.48,293.9c.12,3.97-3.17,7.51-6.99,7.51-3.5,0-7.01-3.56-6.97-7.09.04-3.99,2.8-6.78,6.83-6.9,4.17-.12,7.01,2.46,7.13,6.48h0Z",
    className: "patternColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M253.64,582.55c-.11,4.15-3.05,7.08-6.92,6.91-3.25-.14-6.82-3.87-6.84-7.15-.02-3.91,3.49-7.03,7.64-6.8,3.77.21,6.24,3.04,6.13,7.03h-.01Z",
    className: "patternColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M323.85,323.38c4.08.07,6.63,3.74,6.63,8.35,0,3.53-1.45,5.71-5.2,5.76-3.52.05-7.01-3.82-6.75-7.65.25-3.7,2.1-6.11,5.32-6.45h0Z",
    className: "patternColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M529.98,323.43c-3.44.11-7.31-2.93-7.46-5.86-.16-3.21,3.07-5.9,6.95-6.18,4.22-.3,6.12,2.17,6.77,5.67.53,2.83-3.16,6.27-6.27,6.37h.01Z",
    className: "patternColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M470,271.73c-2.84-.28-5.35-2.1-5.42-6.07-.07-4.01,2.49-5.89,6.19-6.17,3.32-.25,6.75,2.92,6.45,6.1-.35,3.62-2.21,6.15-7.22,6.14Z",
    className: "patternColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M591.46,496.52c-3.26-.32-5.64-2.13-4.74-5.37.55-2,2.91-4.5,4.85-4.91,3.19-.67,5.35,1.99,5.31,5.12-.03,3.05-1.73,5.36-5.42,5.16Z",
    className: "patternColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M491.02,644.57c-3.67,0-5.46-1.44-5.5-4.73-.05-3.2,1.62-5.11,4.7-5.22,3.27-.11,5.25,1.62,5.25,5.13,0,3.31-1.81,4.73-4.45,4.82h0Z",
    className: "patternColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M336.85,467.87c-4.95-1.17-9.59-2.27-14.23-3.36-.13-.6-.27-1.21-.4-1.81,2.68-.9,5.38-2.57,8.05-2.52,3.82.08,6.28,2.66,6.59,7.69h0Z",
    className: "patternColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M438.87,214.27c-3.29,2.37-5.26,4.85-6.79,4.6-1.73-.28-4.2-2.97-4.24-4.67-.04-1.54,2.61-4.2,4.33-4.43,1.56-.21,3.47,2.2,6.7,4.49h0Z",
    className: "patternColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M448.39,146.95c-1.58-2.68-3.18-4.18-2.97-5.37.22-1.21,2.11-2.7,3.46-2.92.8-.13,2.76,1.97,2.75,3.06,0,1.32-1.53,2.64-3.24,5.23Z",
    className: "patternColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternI);
export default __webpack_public_path__ + "static/media/patternI.9c2ba4ef1b9c50423858cb02f0a0840b.svg";
export { ForwardRef as ReactComponent };